import React, { useMemo } from 'react';

import { FilterBadgeProps } from '../../../../../helpers/filterBadges/types';
import { IdFilterFields } from '../../../../../types';

import { useLifestyleGammas } from '../../../hooks/useLifestyleGammas';

import { ItemsFilterBadge } from '../../../../../helpers/filterBadges/ItemsFilterBadge';

import { categoriesKeys } from '../../../../../locales/keys';

import { LifestyleCache } from '../../../LifestyleCache';

interface LifestyleGammasFilterBadgeItem {
  id: string;
  label: string;
}

function LifestyleGammasFilterBadge({
  filters,
  name,
  onRemoveFilter
}: FilterBadgeProps) {
  const { lifestyleGammas } = useLifestyleGammas({
    cacheKey: LifestyleCache.gammasFilterCacheKey()
  });

  const LifestyleGammasFilterBadgeItems = useMemo<
    LifestyleGammasFilterBadgeItem[]
  >(() => {
    return lifestyleGammas.map((category) => ({
      id: category.id as string,
      label: category.localizedName
    }));
  }, [lifestyleGammas]);

  return (
    <ItemsFilterBadge
      dataGa="lifestyles-gammas-filter-badge-clear"
      filters={filters}
      i18nLabel={categoriesKeys.gammas.singular}
      items={LifestyleGammasFilterBadgeItems}
      name={name}
      onRemoveFilter={onRemoveFilter}
      filterField={IdFilterFields.IN}
    />
  );
}

export default LifestyleGammasFilterBadge;
